export default __webpack_public_path__ + "media/zurb/img/home/nema-img-6b7e4ab37a0e37577488e77595985181.jpg";